package org.example.project.engineletter

import androidx.compose.runtime.Composable
import org.example.project.engineletter.layouts.CRLayoutSysDocument
import org.example.project.utils.All

@Composable
fun RenderCrLetterSys(
    rootElementId: String? = null,
    ticket: All,
    kunde: All?,
    unternehmen: All,
    logoSrc: String,
    briefText: String,
    betreffText: String = ticket.crNummer.ifBlank { "CR-${ticket.id}" },
    firmenIdText: String = "",
    ortDatumText: String = "",
    signaturBildSrc: String,
    signaturNameText: String,
    grussformelText: String = ""
) {
    CRLayoutSysDocument(
        rootElementId = rootElementId,
        ticket = ticket,
        kunde = kunde,
        unternehmen = unternehmen,
        logoSrc = logoSrc,
        betreffText = betreffText,
        firmenIdText = firmenIdText,
        briefText = briefText,
        grussformelText = grussformelText,
        ortDatumText = ortDatumText,
        signaturBildSrc = signaturBildSrc,
        signaturNameText = signaturNameText
    )
}
